import { FormikConsumer } from 'formik';
import Checkboxes from '../form/base/Checkboxes';
import Collapse, { Panel } from 'rc-collapse';
import React, { Component } from 'react';
import RequiredSpan from '../form/base/RequiredSpan';

class AudienceTab extends Component {
  constructor(props) {
    super(props);

    this.state = { showAudError: false, showLangError: false };
  }

  render() {
    const { formData, nextTab } = this.props;
    const requiredHeader = (header) => {
      return (
        <span>{header} <RequiredSpan /></span>
      )
    };

    return (
      <FormikConsumer>
        {({ errors, touched }) => (
          <div>
            <h2>Audiences Served</h2>
            <div className="description">Please select at least one Audience and at least one Language</div>
            {(touched['audiences'] && errors['audiences']) && <div className="form-error-message">
              Please select at least one audience.
            </div>}
            <Collapse accordion={false} defaultActiveKey={['0']}>
              <Panel header={requiredHeader('Audiences')}>
                <Checkboxes
                  hasError={touched['audiences'] && errors['audiences']}
                  options={formData.audiences}
                  name="audiences" />
              </Panel>
            </Collapse>
            {(touched['languages'] && errors['languages']) && <div className="form-error-message">
              Please select at least one language.
            </div>}
            <Collapse accordion={false} defaultActiveKey={['0']}>
              <Panel header={requiredHeader('Languages')}>
                <Checkboxes
                  hasError={touched['languages'] && errors['languages']}
                  options={formData.languages}
                  name="languages" />
              </Panel>
            </Collapse>
            <div className="submit">
              <button type="button" className='usa-button' onClick={nextTab}>Save and continue</button>
            </div>
          </div>
        )}
      </FormikConsumer>
    )
  }
}

export default AudienceTab;
